module.exports = __webpack_public_path__ + "static/img/head2.80416e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/common/head2.png
// module id = Xceu
// module chunks = 1